<template>
  <tabs />
  <div class="main-area h-full">
    <div class="mx-12">
      <ControlledTourMap :auto-center="true" :lazy="false" :has-campaign-filter="true" :has-embedded-date-range="true" :campaign-group="modelValue" :useBounds="false"  :filter="{}" :initial-zoom="9"/>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import DataTable, { type Column } from '@utils/table/Table.vue';
import type { Filter } from '@utils/filter/Filter.vue';
import Tabs from '@components/structure/navigation/Tabs.vue';
import type {
  CampaignGroup,
} from '@/entities/Entities';
import ControlledTourMap from '@components/utils/maps/ControlledTourMap.vue';
import { useQueryRef } from "@/hooks/url";

interface Props {
  modelValue: CampaignGroup;
}

const props = defineProps<Props>();

const sortKey = useQueryRef<string | undefined>("sortKey", undefined);
const sortDirection = useQueryRef<'ASC' | 'DESC' | undefined>("sortDirection", undefined);

const { t } = useI18n();

</script>

<style lang="scss" scoped>
button {
  @apply block;
}

.table {
  @apply flex flex-col;
}
</style>
